import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { MultiSelectFilterPicker } from 'seagull';
import { proposalStatusDefinition } from '../ProposalsDashboard.utils';
export function ProposalsProgressStatusFilterPicker(props) {
    const { isVendor, onChange, value, counters } = props;
    const options = useMemo(()=>{
        const statusDefinition = proposalStatusDefinition(isVendor);
        const availableStatuses = Object.keys(counters);
        return Object.keys(statusDefinition).filter((status)=>availableStatuses.indexOf(status) > -1).sort((statusNameA, statusNameB)=>statusDefinition[statusNameB].severity - statusDefinition[statusNameA].severity).map((statusName)=>{
            return {
                label: statusDefinition[statusName].statusText,
                value: statusName,
                counter: counters[statusName]
            };
        });
    }, [
        isVendor,
        counters
    ]);
    return /*#__PURE__*/ _jsx(MultiSelectFilterPicker, {
        testId: 'proposals-progress-status-filter-picker',
        value: value,
        label: "Proposal status",
        options: options,
        onChange: onChange
    });
}
